module.exports = __webpack_public_path__ + "static/img/whitebg.15afd0db.png";